import { useEffect, useState } from 'react';

export default function useCountry() {
  const [country, setCountry] = useState('IN');
  const [isFetching, setIsFetching] = useState(true);
  const isIndia = country === 'IN';
  const isWebview = () => !!window.ReactNativeWebView || !!window.isExpoWebView;

  useEffect(() => {
    const fetchMyIp = async () => {
      setIsFetching(true);
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    };

    const fetchCountry = async () => {
      if (isWebview()) {
        return;
      }

      setIsFetching(true);
      const myip = await fetchMyIp();
      fetch(`https://api.ipinfo.io/lite/${myip}?token=3a2317bc825213`)
        .then((res) => res.json())
        .then((data) => {
          setCountry(data.country_code);
        })
        .catch(() => setCountry(null))
        .finally(() => setIsFetching(false));
    };

    fetchCountry();
  }, []);

  return { country, isIndia, isFetchingCountry: isFetching };
}
